import { useMemo } from "react";
import { Link } from "react-router-dom";
import { ArrowDownUp, Trash2 } from "lucide-react";

interface ColumnsProps {
  onClickDelete: (data: any) => void;
  onClickUpdate: (data: any) => void;
  onclickSort: (data: any) => void;
}

const RegisterPoisonFactorycolumns = ({
  onClickDelete,
  onClickUpdate,
  onclickSort,
}: ColumnsProps) => {
  const RegisterPoisonFactorycolumns = useMemo(
    () => [
      {
        header: "سال زارع",
        accessorKey: "crop_year_name",
        enableColumnFilter: false,
      },
      {
        header: "نام کارخانه",
        accessorKey: "factory_name",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: () => (
          <div
            className="flex items-center gap-1"
            onClick={() => onclickSort("farmer_price")}
          >
            <span>
              قیمت کشاورز{" "}
              <span className="text-blue-600 text-[10px]">(ریال)</span>
            </span>
            <ArrowDownUp className="text-blue-800" size={16} />
          </div>
        ),
        accessorKey: "farmer_price",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: () => (
          <div
            className="flex items-center gap-1"
            onClick={() => onclickSort("factory_price")}
          >
            <span>
              قیمت کارخانه{" "}
              <span className="text-blue-600 text-[10px]">(ریال)</span>
            </span>
            <ArrowDownUp className="text-blue-800" size={16} />
          </div>
        ),
        accessorKey: "factory_price",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: () => (
          <span className="flex" onClick={() => onclickSort("unit_name")}>
            واحد
            {/* <ArrowDownUp size={15} className="text-gray-500 gap-2" /> */}
          </span>
        ),
        accessorKey: "unit_name",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: "نام سم",
        accessorKey: "pesticide_name",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: () => (
          <span className="flex" onClick={() => onclickSort("amount")}>
            مقدار
            <ArrowDownUp size={15} className="text-gray-500 gap-2" />
          </span>
        ),
        accessorKey: "amount",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: "تاریخ ایجاد",
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "عملیات",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <Link to="#" onClick={() => onClickDelete(cell.row.original)}>
              <span className="rounded p-2 w-20 ml-3 bg-red-800 text-white">
                حذف
              </span>
            </Link>
            <Link to="#" onClick={() => onClickUpdate(cell.row.original)}>
              <span className="rounded p-2 w-20 ml-3 bg-red-800 text-white">
                ویرایش
              </span>
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  return RegisterPoisonFactorycolumns;
};

export default RegisterPoisonFactorycolumns;
